import dynamic from "next/dynamic";
import FlexibleCardsGridConfig from "./flexible-cards-grid-config";
import FlexibleCardsGridAdvancedConfig from "./flexible-cards-grid-advanced-config";
const FlexibleCardsGridComponent = dynamic(()=>import("./flexible-cards-grid-component"));
export default {
    FlexibleCardsGridComponent,
    FlexibleCardsGridConfig,
    FlexibleCardsGridAdvancedConfig
};
